import CountCell from 'components/CountCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function PlatformAccountsCountCell({
  rowData: { id, totals, oemSegment },
}: CellProps) {
  return (
    <CountCell
      count={totals?.platformAccounts}
      pageParams={{
        tab: 'accounts',
        teamIds: [id],
        oemSegmentIds: oemSegment?.id ? [oemSegment?.id] : [],
        accountIds: [],
        depotIds: [],
      }}
    />
  );
}
